import React from 'react';

import EnvironmentDay2024  from 'views/EnvironmentDay2024';

const CareerOpeningPage = () => {
  return <EnvironmentDay2024 />;
};

export default CareerOpeningPage;
